import { useEffect, useState } from 'react'

interface IBreakpoint {
  tag: string,
  width: number,
}
const breakpoints: IBreakpoint[] = [
  { tag: '', width: 0 },
  { tag: 'sm', width: 640 },
  { tag: 'md', width: 768 },
  { tag: 'lg', width: 1024 },
  { tag: 'xl', width: 1280 },
  { tag: '2xl', width: 1536 },
]

export default () => {
  const [width, setWidth] = useState(window.innerWidth)

  const getMatchingBreakpoints = () => breakpoints
    .filter((breakpoint: IBreakpoint) => breakpoint.width <= width)
    .sort((a: IBreakpoint, b: IBreakpoint) => a.width - b.width)

  const getBreakpoint = () => getMatchingBreakpoints()[0] ?? ''

  const compareTag = (tag?: 'sm'|'md'|'lg'|'xl'|'2xl'): boolean => !!getMatchingBreakpoints()
    .filter((breakpoint: IBreakpoint) => breakpoint.tag === tag)
    .length

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return {
    getBreakpoint,
    compareTag,
  }
}
